<template>
  <div class="content" ref="content">
    <div class="earth-banner" ref="earthBanner">
      <div class="earth-word" ref="earthWord">
        <div class="">
          <img v-if="iscn" src="../assets/bingchuan-title.png" class="bingchuan-title" alt="">
          <img v-else src="../assets/bingchuan-title-en.png" class="bingchuan-title bingchuan-title-en" alt="">
        </div>
        <div class="">
          <img src="../assets/bingchuan-bg.png" class="bingchuan-bg" alt="">
        </div>
        <div class="">
          <img v-if="iscn" src="../assets/bingchuan-mark-1.png" class="bingchuan-mark-1 animate__animated" alt="">
          <img v-else src="../assets/glacier-tongue.png" class="bingchuan-mark-1 bingchuan-mark-1-en animate__animated" alt="">
        </div>
        <div class="">
          <img v-if="iscn" src="../assets/bingchuan-mark-2.png" class="bingchuan-mark-2 animate__animated" alt="">
          <img v-else src="../assets/mark-of-glacier-tongue.png" class="bingchuan-mark-2 bingchuan-mark-2-en animate__animated" alt="">
        </div>
        <div class="">
          <img v-if="iscn" src="../assets/bingchuan-31.png" class="bingchuan-31 animate__animated" alt="">
          <img v-else src="../assets/bingchuan-31-en.png" class="bingchuan-31 animate__animated" alt="">
        </div>
        <div class="">
          <img src="../assets/bingchuan-arrow.png" class="bingchuan-arrow animate__animated" alt="">
        </div>
        <div class="">
          <img src="../assets/bingchuan-co2.png" class="bingchuan-co2 animate__animated" alt="">
        </div>
        <div class="">
          <img src="../assets/bingchuan-sweat.png" class="bingchuan-sweat animate__animated" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Rellax from 'rellax'

export default Vue.extend({
  name: 'earth-waring-area',
  computed: {
    iscn: function() {
      return this.$store.state.lang === 'zh-cn'
    }
  },
  mounted() {
    this.initAnimation()

    new Rellax('.bingchuan-title', {
      speed: -0.5,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
    new Rellax('.bingchuan-bg', {
      speed: 1,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
    new Rellax('.bingchuan-mark-1', {
      speed: 1,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
    new Rellax('.bingchuan-mark-2', {
      speed: 1,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
    new Rellax('.bingchuan-31', {
      speed: 1,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
    new Rellax('.bingchuan-co2', {
      speed: 1,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
  },
  methods: {
    initAnimation() {
      // 监听滚动事件，当元素earthPic进入视口时，给元素增加动画类
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // 冰川图部分
            if (entry.target.classList.contains('bingchuan-title') && entry.isIntersecting) {
              setTimeout(() => {
                document.querySelector('.bingchuan-title')?.classList?.add('fade-in')
              }, 70)
            }
            if (entry.target.classList.contains('bingchuan-bg') && entry.isIntersecting) {
              setTimeout(() => {
                document.querySelector('.bingchuan-bg')?.classList?.add('zoom-in')
              }, 70)
              setTimeout(() => {
                document.querySelector('.bingchuan-mark-1')?.classList?.add('animate__fadeIn')
                setTimeout(() => {
                  document.querySelector('.bingchuan-mark-2')?.classList?.add('animate__fadeIn')
                }, 200)
              }, 1000)
            }
            // co2
            if (entry.target.classList.contains('bingchuan-31') && entry.isIntersecting) {
              setTimeout(() => {
                document.querySelector('.bingchuan-31')?.classList?.add('zoom-in')
                setTimeout(() => {
                  document.querySelector('.bingchuan-arrow')?.classList?.add('zoom-in')
                  document.querySelector('.bingchuan-co2')?.classList?.add('zoom-in')
                  document.querySelector('.bingchuan-sweat')?.classList?.add('zoom-in')
                }, 200)
              }, 70)
            }
          })
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.2
        }
      )
      observer.observe(document.querySelector('.bingchuan-title') as Element)
      observer.observe(document.querySelector('.bingchuan-bg') as Element)
      observer.observe(document.querySelector('.bingchuan-31') as Element)
    }
  }
})
</script>

<style scoped lang="scss">
@keyframes zoomIn {
  from {
    transform: scale3d(0.7, 0.7, 0.7);
    opacity: 0;
  }

  50% {
    opacity: 0.3;
  }

  to {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}

@keyframes zoomInPic {
  from {
    transform: scale3d(0.9, 0.9, 0.9);
    opacity: 0;
  }

  to {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(200px);
  }

  to {
    transform: translateY(0);
  }
}

.fade-in {
  animation: fadeIn 1s 0s forwards;
}

.zoom-in {
  animation: zoomIn 1s 0s forwards;
  animation-timing-function: linear;
}

.zoom-in-fast {
  animation: zoomIn 800ms 0s forwards;
  animation-timing-function: linear;
}

.zoom-in-pic {
  animation: zoomInPic 1s 0s forwards;
}

.earth-banner-up {
  animation: slideUp 0.8s 0s forwards;
}

.content {
  position: relative;
  z-index: 3;
  width: 1920px;
  min-width: 1280px;
  max-width: 1920px;
  height: 2004px;
  margin: 0 auto;
  background: #fff;
}

.earth-banner {
  position: absolute;
  top: 0;
  text-align: center;
  width: 1538px;
  left: 50%;
  // width: 1539px;
  // height: 807px;
  margin-left: -769px;
  // background: url('../assets/pic-5.png') no-repeat 0 0/ 100% 100%;
  // y轴向下偏移100像素
  // transform: translateY(200px);
  .bingchuan-title {
    width: 992px;
    // height: 96px;
    margin: 0 auto;
    position: absolute;
    left: 50%;
    margin-left: -486px;
    opacity: 0;
    &.bingchuan-title-en {
      width: 1691px;
      // height: 96px;
      margin-left: -846px;
    }
  }
  .bingchuan-bg {
    position: absolute;
    top: 216px;
    left: 50%;
    width: 1538px;
    height: 720px;
    margin-left: -769px;
    opacity: 0;
  }
  .bingchuan-mark-1 {
    position: absolute;
    top: 342px;
    left: 263px;
    width: 232px;
    height: 108px;
    opacity: 0;
    &.bingchuan-mark-1-en {
      width: 343px;
    }
  }
  .bingchuan-mark-2 {
    position: absolute;
    top: 642px;
    left: 114px;
    width: 481px;
    height: 48px;
    opacity: 0;
    &.bingchuan-mark-2-en {
      width: 514px;
    }
  }
  .bingchuan-31 {
    position: absolute;
    top: 1136px;
    left: 0px;
    width: 640px;
    height: 588px;
    opacity: 0;
  }
  .bingchuan-arrow {
    position: absolute;
    top: 1411px;
    left: 734px;
    width: 32px;
    height: 37px;
    opacity: 0;
  }
  .bingchuan-co2 {
    position: absolute;
    top: 1180px;
    left: 834px;
    width: 652px;
    height: 500px;
    opacity: 0;
  }
  .bingchuan-sweat {
    position: absolute;
    top: 1218px;
    left: 1405px;
    width: 125px;
    height: 114px;
    opacity: 0;
  }
}
</style>
